module.exports = __webpack_public_path__ + "static/img/img-6.e573194.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-6.png
// module id = 09/C
// module chunks = 0